import React from 'react';

import './blog-post-pull-quote.scss';

const PullQuote = ({ imageUrl, quote }) => {
  const baseClassNames = [
    'blog-post-pull-quote',
    imageUrl && 'blog-post-pull-quote--image'
  ].filter(Boolean).join(' ');

  return (
    <div className={baseClassNames}>
      {imageUrl && (
        <div className="blog-post-pull-quote__image">
          <img
            className="blog-post-pull-quote__image__image"
            src={imageUrl + '?fm=jpg&q=80&w=450&h=450&fl=progressive'}
          />
        </div>
      )}
      <div className="blog-post-pull-quote__quote">{quote}</div>
    </div>
  );
};

export default PullQuote;



// WEBPACK FOOTER //
// ./src/components/blog-post-pull-quote.js